__turbopack_context__.v({
  "details": "UNb4Ma_details",
  "dismiss": "UNb4Ma_dismiss",
  "message": "UNb4Ma_message",
  "root": "UNb4Ma_root",
  "title": "UNb4Ma_title",
});
